import { render } from "./RichLastWeekTabCont.vue?vue&type=template&id=85436a74"
import script from "./RichLastWeekTabCont.vue?vue&type=script&lang=js"
export * from "./RichLastWeekTabCont.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__